'use strict';

var DoohApps = angular.module('DoohApps', ['ngResource', 'ngAnimate', 'ngRoute', 'ngSanitize', 'ngCookies', 'ui.bootstrap', 'multi-select', 'angular.filter', 'ui-notification', 'ngTagsInput', 'ngDragDrop', 'colorpicker.module', 'dibari.angular-ellipsis', 'gridster', 'azureBlobUpload', 'cfp.hotkeys', 'gettext', 'oc.lazyLoad', 'ng.jsoneditor', 'ui.calendar']);

angular.module('DoohApps').controller('MainCtrl', ['$rootScope', '$scope', '$location', '$controller', '$routeParams', '$timeout', 'accountBLL', 'DialogHandler', 'hotkeys', '$uibModal', 'User',
    function ($rootScope, $scope, $location, $controller, $routeParams, $timeout, accountBLL, DialogHandler, hotkeys, $uibModal, User) {
        $scope.navMenuVisible = false;
        $rootScope.location = $location.$$path;

        $rootScope.changeLanguage = function () {
            User.changeLanguage();
            accountBLL.changeLanguage(function () { }, User.language);
        }

        $scope.navMenu = function () {
            $scope.navMenuVisible = !$scope.navMenuVisible;
        };

        var mainCssRemaining = 3;

        $scope.MainCssLoaded = function (event) {
            if (event)
                mainCssRemaining--;
            if (mainCssRemaining <= 0)
                return true;
            return false;
        };

        //Keyboard shortcuts
        //$scope.cn - controller name, cs - controller scope, cm - controller modal service. Because names too long that's why...

        hotkeys.add({
            combo: 'ctrl+down',
            description: 'Move to next input element',
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: function (e) {
                focusNext(e);
                e.preventDefault();
            }
        });
        hotkeys.add({
            combo: 'ctrl+up',
            description: 'Move to previous input element',
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: function (e) {
                focusPrevious(e);
                e.preventDefault();
            }
        });

        hotkeys.add({
            combo: 'alt+s',
            description: 'Save currently opened form',
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: function (e) {
                var funFound = false;
                switch ($scope.cn) {
                    case 'AppInbox':
                        if ($scope.cm.isActive('Configurator')) {
                            funFound = true;
                            e.preventDefault();
                            $scope.cs.saveConfiguration();
                        }
                        break;

                    case 'MediaAssets':
                        if ($scope.cm.isActive('NewFolder')) {
                            funFound = true;
                            e.preventDefault();
                            if ($scope.cs.FolderCU == 'U')
                                $scope.cs.updateFolder();
                            else if ($scope.cs.FolderCU == 'C')
                                $scope.cs.addFolder();
                        }
                        else if ($scope.cm.isActive('NewAsset')) {
                            e.preventDefault();
                            $scope.cs.SaveNewMediaAsset();
                        }
                        else if ($scope.cm.isActive('EditAsset')) {
                            funFound = true;
                            e.preventDefault();
                            $scope.cs.SaveNewMediaAsset();
                        }
                        break;

                    case 'Schedule':
                        if ($scope.cm.isActive('ScheduleEvent')) {
                            funFound = true;
                            e.preventDefault();
                            $scope.cs.SaveSchedule();
                        }
                        break;
                    case 'Devices':

                        break;

                    case 'Admin':
                        if ($scope.cm.isActive('NewConfiguration')) {
                            funFound = true;
                            e.preventDefault();
                            if ($scope.cs.isNewConfig)
                                $scope.cs.createConfig();
                            else $scope.cs.renameConfiguration();
                        }
                        else if ($scope.cm.isActive('newDevice')) {
                            funFound = true;
                            e.preventDefault();
                            $scope.cs.createDevice();
                        }
                        else if ($scope.cm.isActive('UserData')) {
                            funFound = true;
                            e.preventDefault();
                            if ($scope.cs.selectedUser.Status != 'Unapproved')
                                $scope.cs.updateUser('save');
                        }
                        else if ($scope.cm.isActive('newCompany')) {
                            funFound = true;
                            e.preventDefault();
                            if (!$scope.cs.newCompany.edit)
                                $scope.cs.SaveNewCompany();
                            else $scope.cs.SaveCompany();
                        }
                        else if ($scope.cm.isActive('RoleData')) {
                            funFound = true;
                            e.preventDefault();
                            $scope.cs.SaveRole();
                        }
                        else if ($scope.cm.isActive('AddCredits')) {
                            funFound = true;
                            e.preventDefault();
                            $scope.cs.AddCredits();
                        }
                        break;

                    case 'Account':
                        if ($scope.cm.isActive('NewProfileImage')) {
                            funFound = true;
                            e.preventDefault();
                            $scope.cs.SaveProfileImage();
                        }
                        else if ($scope.cm.isActive('EditUserDetails')) {
                            funFound = true;
                            e.preventDefault();
                            $scope.cs.UpdateUserDetails();
                        }
                        else if ($scope.cm.isActive('ChangePassword')) {
                            funFound = true;
                            e.preventDefault();
                            $scope.cs.ChangePassword();
                        }
                        else if ($scope.cm.isActive('Invite')) {
                            funFound = true;
                            e.preventDefault();
                            $scope.cs.SendInvitation();
                        }

                        break;
                    default: break;
                }
                if (!funFound) {
                    if ($scope.cm.isActive('mediaAssetsPopup')) {
                        e.preventDefault();
                        $scope.cs.SaveNewMediaAsset();
                    }
                    else if ($scope.cm.isActive('TransitionLogo')) {
                        e.preventDefault();
                        $scope.cs.SaveTransitionLogo();
                    }
                    else if ($scope.cm.isActive('ScreenDetails')) {
                        e.preventDefault();
                        $scope.cs.UpdateSettings(false);
                    }
                    else if ($scope.cm.isActive('AppEdit')) {
                        e.preventDefault();
                        if ($scope.cs.editTabs.Active == 'Basic') {
                            if (!$scope.cs.isNewApp)
                                $scope.cs.UpdateAppDetails('false');
                            else $scope.cs.CreateNewApp();
                        }
                        else if ($scope.cs.editTabs.Active == 'Versions') {
                            if ($scope.cs.editVersionTabs.Active == 'Version')
                                $scope.cs.UpdateAppVersion();
                            else if ($scope.cs.editVersionTabs.Active == 'Requirements')
                                $scope.cs.saveRequirementChanges();
                            else if ($scope.cs.editVersionTabs.Active == 'Images')
                                $scope.cs.saveAppImages();
                            else if ($scope.cs.editVersionTabs.Active == 'Configurator')
                                $scope.cs.confirmConfigSave();
                        }
                    }
                    else if ($scope.cm.isActive('ExeActions')) {
                        e.preventDefault();
                        if (!$scope.cs.isNewExeAction)
                            $scope.cs.updateExeAction();
                        else $scope.cs.createExeAction();
                    }
                    else if ($scope.cm.isActive('appRequirements')) {
                        e.preventDefault();
                        $scope.cs.addNewRequirement();
                    }
                    else if ($scope.cm.isActive('ConfiguratorBlock')) {
                        e.preventDefault();
                        if (!$scope.cs.newGroup && $scope.cs.isNewConfigBlock)
                            $scope.cs.createBlock();
                        else if (!$scope.cs.newGroup && !$scope.cs.isNewConfigBlock)
                            $scope.cs.updateBlock();
                        else if ($scope.cs.newGroup && $scope.cs.isNewConfigBlock)
                            $scope.cs.addBlockGroup();
                        else if ($scope.cs.newGroup && !$scope.cs.isNewConfigBlock)
                            $scope.cs.renameBlockGroup();
                    }
                }
            }
        });

        hotkeys.add({
            combo: 'alt+d',
            description: 'Save currently opened form and close/schedule etc.',
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: function (e) {
                var funFound = false;
                switch ($scope.cn) {
                    case 'AppInbox':
                        if ($scope.cm.isActive('Configurator')) {
                            funFound = true;
                            e.preventDefault();
                            $scope.cs.saveAndScheduleConfiguration();
                        }
                        break;

                    case 'Devices':

                        break;

                    default: break;
                }
                if (!funFound) {
                    if ($scope.cm.isActive('ScreenDetails')) {
                        e.preventDefault();
                        $scope.cs.UpdateSettings(true);
                    }
                    else if ($scope.cm.isActive('AppEdit')) {
                        e.preventDefault();
                        if ($scope.cs.editTabs.Active == 'Basic') {
                            if (!$scope.cs.isNewApp)
                                $scope.cs.UpdateAppDetails('true');
                        }
                    }
                }
            }
        });
        hotkeys.add({
            combo: 'alt+y',
            description: 'Confirm dialog',
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: function (e) {
                var funFound = false;
                switch ($scope.cn) {
                    case 'AppInbox':
                        if ($scope.cm.isActive('DeleteCampaignConfirmation')) {
                            funFound = true;
                            e.preventDefault();
                            if (!$scope.cs.cantDel && !$scope.cs.savePressed)
                                $scope.cs.DeleteCampaign();
                            else if (!$scope.cs.savePressed && !$scope.cs.upgradeMode && $scope.cs.saveMode)
                                $scope.cs.ConfirmSave();
                            else if (!$scope.cs.savePressed && $scope.cs.saveMode && $scope.cs.upgradeMode)
                                $scope.cs.confirmUpgrade();
                        }
                        break;

                    case 'MediaAssets':
                        if ($scope.cm.isActive('DeleteFolder')) {
                            e.preventDefault();
                            $scope.cs.deleteFolder($scope.cs.delFolder.node);
                        }
                        break;

                    case 'Admin':
                        if ($scope.cm.isActive('DeleteUser')) {
                            funFound = true;
                            e.preventDefault();
                            $scope.cs.DeleteUser();
                        }
                        else if ($scope.cm.isActive('ResetPassAdmin')) {
                            funFound = true;
                            e.preventDefault();
                            $scope.cs.resetUserpassword();
                        }
                        else if ($scope.cm.isActive('DeleteCompany')) {
                            funFound = true;
                            e.preventDefault();
                            if ($scope.cs.companyDel)
                                $scope.cs.DeleteCompany();
                        }
                        else if ($scope.cm.isActive('AccessDelete')) {
                            funFound = true;
                            e.preventDefault();
                            if ($scope.cs.companyDel)
                                $scope.cs.DeleteRole();
                        }
                        else if ($scope.cm.isActive('VoucherInvalidateConfirmation')) {
                            funFound = true;
                            e.preventDefault();
                            $scope.cs.setVoucherInvalid();
                        }
                        break;

                    default: break;
                }
                if (!funFound) {
                    if ($scope.cm.isActive('DeviceGroupDelete')) {
                        e.preventDefault();
                        if ($scope.cs.delDev)
                            $scope.cs.deleteDevice();
                        else $scope.cs.ConfirmDeleteConfig();
                    }
                    else if ($scope.cm.isActive('DeleteVersionFileConfirm')) {
                        e.preventDefault();
                        $scope.cs.deleteVersionFile();
                    }
                    else if ($scope.cm.isActive('ExeActionDeleteConfirm')) {
                        e.preventDefault();
                        $scope.cs.deleteExeAction();
                    }
                    else if ($scope.cm.isActive('ConfiguratorBlockDelete')) {
                        e.preventDefault();
                        if ($scope.cs.blockDelete == 0)
                            $scope.cs.deleteBlock();
                        else if ($scope.cs.blockDelete == 1)
                            $scope.cs.deleteGroup();
                        //else if ($scope.cs.blockDelete == 2) //not sure how to get to this one
                        //    $scope.cs.saveConfigurationBlocks();
                    }
                    else if ($scope.cm.isActive('DeleteApp')) {
                        e.preventDefault();
                        $scope.cs.DeleteApp();
                    }
                }
            }
        });
    }]);

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}